export default __webpack_public_path__ + "static/media/4.25630e36.jpg";